import React from 'react';
import { TenantAssets } from '../generated/api';
import { TenantAsset } from '../careand-redux/selectors';
import { useAppSelector } from '../careand-redux/store';
import iconColor from 'assets/img/logo-and-blue.webp';
import logoColor from 'assets/img/logo-blue-horizontal.webp';
import logoWhite from 'assets/img/logo-white-horizontal.webp';
import logoFullColor from 'assets/img/logo-full-blue.webp';
import logoFullWhite from 'assets/img/logo-full-blue.webp';

type Props = Omit<React.ComponentPropsWithoutRef<'img'>, 'src'> & { src: keyof TenantAssets };

const TenantImg = ({ src, ...props }: Props) => {
  const url = useAppSelector(TenantAsset(src)) ?? getDefaultTenantImg(src);
  return <img src={url} {...props} />;
};

const getDefaultTenantImg = (src: keyof TenantAssets) => {
  switch (src) {
    case 'logo_color':
      return logoColor;
    case 'logo_white':
      return logoWhite;
    case 'logo_full_color':
      return logoFullColor;
    case 'logo_full_white':
      return logoFullColor; // TODO we don't have a white
    case 'icon_color':
      return iconColor;
    case 'icon_white':
      return iconColor; // TODO we don't have a white
    case 'favicon':
      return undefined;
  }
};

export default TenantImg;
